import { makeSx } from '../../../theme/_utils'

export default makeSx({
    callout: {
        padding: '1.15rem',
    },
    calloutIconContainer: {
        '& svg': {
            width: '1.5rem',
            height: '1.5rem',
        },
    },
    calloutContentContainer: {
        fontWeight: 600,
    },
})
